export interface ITransaction {
  completionDate: Date;
  type: string;
  amount: number;
  tooltips: TooltipEntry[];
  cancelled: boolean;
}

export class Transaction implements ITransaction {
  completionDate: Date;
  type: string;
  amount: number;
  tooltips: TooltipEntry[];
  cancelled: boolean;

  constructor(completionDate: Date, type: string, amount: number) {
    this.completionDate = completionDate;
    this.type = type;
    this.amount = amount;
    this.cancelled = false;
  }
}

export class TooltipEntry {
  key: string;
  value: string;
}
